export const initialFilter = {
  filter: {
    name: "",
  },
  search: "",
  sortOrder: "desc", // asc||desc
  sortField: "created_at",
  pageNumber: 1,
  pageSize: 10,
};
